
export const DDAction = {
	SHOW_DROP_DOWN : "show",
	HIDE_DROP_DOWN : "hide",
	DISABLE: "disable",
	ENABLE: "enable"
}

export const DDEvent = {
	WIDGET_FOCUS: "widget-focus",
	WIDGET_BLUR: "widget-blur",
	WIDGET_MOUSE_DOWN: "widget-mouse-down",
	PANEL_ENTER: "panel-enter",
	PANEL_LEAVE: "panel-leave",
	BODY_CANCEL: "body-cancel",
	SELECTION_DONE: "selection-done"
}

export class DropDownStateMachine {

	/**
	 * @param {boolean} multi selection
	 * @param {boolean} readOnly editor
	 * @param {string} field name to help with debugging
	 */
	constructor(multi, readOnly, field = "categories") {
		this.actionListeners = [];
		this.widgetFocused = false;
		this.inPanel = false;
		this.dropDownOpen = false;
		this._multi = multi;
		this._readOnly = readOnly;
		this.field = field;
	}

	get multi() {
		return this._multi;
	}

	set multi(value) {
		this._multi = value;
	}

	get readOnly() {
		return this._readOnly;
	}

	set readOnly(value) {
		const change = this._readOnly != !!value;
		this._readOnly = value;
		if (change) this.fire(this._readOnly ? DDAction.DISABLE : DDAction.ENABLE);
	}

	/**
	 * @param {function} actionListener
	 */
	listen(actionListener) {
		this.actionListeners.push(actionListener);
	}

	fire(action, extraParam) {
		//console.log(this.field + ":action " + action);
		for (let l of this.actionListeners) {
			l(action, extraParam);
		}
	}

	/**
	 * Call this on a event
	 * @param {string} name
	 * @param {*} extraParam
	 */
	event(name, extraParam = null) {
		//console.log(this.field + ":event " + name);
		switch (name) {
			case DDEvent.WIDGET_FOCUS:
				this.openIfClosed();
				/*if (this.readonly || this.disabled) {
					this.dd.shouldBeHidden(true);
				} else {
					this.dd.shouldBeVisible();
					setTimeout(() => {
						console.log("Click handler on");
						this.widget.on("click.ce", this.widgetClicked.bind(this));
					}, 500);
				}*/
				break;
			case DDEvent.WIDGET_BLUR:
				this.closeIfOpen();
				//this.widget.off("click.ce");
				break;
			case DDEvent.WIDGET_MOUSE_DOWN:
				break;
			case DDEvent.PANEL_ENTER:
				this.inPanel = true;
				break;
			case DDEvent.PANEL_LEAVE:
				this.inPanel = false;
				break;
			case DDEvent.BODY_CANCEL:
				this.closeIfOpen(false);
				break;
			case DDEvent.SELECTION_DONE:
				this.closeIfOpen(true);
				break;
		}
	}

	closeIfOpen(force) {
		if ((!this.inPanel || force) && this.dropDownOpen) {
			this.fire(DDAction.HIDE_DROP_DOWN);
			this.dropDownOpen = false;
		}
	}

	openIfClosed() {
		if (!this._readOnly && !this.dropDownOpen) {
			this.fire(DDAction.SHOW_DROP_DOWN);
			this.dropDownOpen = true;
		}
	}
}